module.exports = __webpack_public_path__ + "../assets/img/229c14e2d105a3e9a1f33b89e9d48483.svg";